<template>
  <div
    id="coupon"
    class="coupon"
    :class="{ touchable: !isListView }"
    @click="$emit('selectCoupon', coupon)"
  >
    <router-link
      v-if="isShowButton"
      tag="span"
      class="link"
      :to="coupon.type >= 100 ? '/courses?type=' + coupon.type : '/homeclass'"
    >
      去使用
      <i class="anyteachicon anyteach-next" />
    </router-link>
    <div v-if="!isListView">
      <i v-if="!coupon.id" class="couponSelectedIcon anyteachicon anyteach-check-circle" />
      <i
        v-else
        :class="{ selected: couponSelected == coupon.id }"
        class="couponSelectedIcon anyteachicon anyteach-check-circle"
      />
    </div>
    <h2>
      <span v-if="coupon.type_name">{{ coupon.type_name }}</span>
      <span v-else>{{ coupon.title }}</span>
      <span v-if="coupon.count" class="card-count">{{ coupon.count }} 张</span>
    </h2>
    <p>
      <span v-if="coupon.condition == 3">
        现金抵扣
        <span class="red">¥{{ coupon.amount }}</span>
      </span>
      <span v-else>{{ coupon.content }}</span>
      <span v-if="coupon.course_event">
        <br />
        <span>仅限</span>
        <span v-for="(value, key) in coupon.course_event" :key="key">
          <b>{{ value.title }} · {{ value.event_title }}</b>
          <span v-if="key != coupon.course_event.length - 1">、</span>
        </span>
      </span>
      <br />
      <span v-if="coupon.deadline">{{ coupon.display_time }} 前使用</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "Coupon",
  props: {
    coupon: Object,
    couponSelected: Number,
    isListView: {
      type: Boolean,
      default: false,
    },
    isShowButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      courseTypes: {
        0: "通用",
        1: "单一约课上门",
        2: "单一主题课",
        3: "约课上门",
        4: "主题课",
        5: "游学",
        6: "单一游学",
        7: "海外游学",
        8: "国内冬夏令营",
        9: "短途游学",
        10: "同城拼课",
      },
      area: {
        0: "全国",
        1: "泉州",
        2: "厦门",
        3: "深圳",
        6: "合肥",
        7: "福州",
      },
    }
  },
  created() {
    this.sortCoupon()
  },
  methods: {
    sortCoupon() {
      this.coupon.display_time = this.$moment(this.coupon.deadline).format("YYYY年M月D日 HH:ss")
      if (this.coupon.type == 0) {
        this.coupon.title = "通用学习券"
      } else if (this.coupon.type == 1 || this.coupon.type == 2 || this.coupon.type == 6) {
        this.coupon.title = `${this.coupon.name}学习券`
      } else {
        this.coupon.title = `${this.courseTypes[this.coupon.type]}学习券`
      }
      if (this.coupon.condition == 2) {
        if (this.coupon.type == 6) {
          this.coupon.content = "抵用任意 1 次课程"
        } else if (this.coupon.type == 1 || this.coupon.type == 2 || this.coupon.type == 6) {
          this.coupon.content = `抵用 1 次${this.coupon.name}课程`
        } else {
          this.coupon.content = `抵用 1 次${this.courseTypes[this.coupon.type]}课程`
        }
      } else if (this.coupon.condition == 3) {
        this.coupon.content = `抵扣现金 ¥${this.coupon.amount}`
      } else {
        if (this.coupon.type == 6) {
          this.coupon.content = `支付任意课程时抵扣 ${this.coupon.amount} 学分`
        } else if (this.coupon.type == 1 || this.coupon.type == 2 || this.coupon.type == 6) {
          this.coupon.content = `支付${this.coupon.name}课程时抵扣 ${this.coupon.amount} 学分`
        } else {
          this.coupon.content = `支付${this.courseTypes[this.coupon.type]}课程时抵扣 ${
            this.coupon.amount} 学分`
        }
      }
    },
  },
}
</script>
<style type="text/css" lang="scss">
// @import "../../../static/css/public.scss";
@import "../../../static/css/coupon.scss";
</style>
